export default __webpack_public_path__ + "static/media/nsfw.5bc33487.png";